import { render, staticRenderFns } from "./AirlineMatrix.vue?vue&type=template&id=284dbdc6&scoped=true"
import script from "./AirlineMatrix.vue?vue&type=script&lang=js"
export * from "./AirlineMatrix.vue?vue&type=script&lang=js"
import style0 from "./AirlineMatrix.vue?vue&type=style&index=0&id=284dbdc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284dbdc6",
  null
  
)

export default component.exports